import acceptSharedCalendarInviteOperation from 'owa-service/lib/operation/acceptSharedCalendarInviteOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
export default function acceptSharedCalendarInvite(messageId) {
    return acceptSharedCalendarInviteOperation({
        Header: getJsonRequestHeader(),
        Body: {
            MessageId: messageId,
        },
    }).then(function (response) {
        return response.Body;
    });
}
//# sourceMappingURL=acceptSharedCalendarInvite.js.map